import React from 'react';
import {capitalize} from "../../../../../../Utils";

const Head = ({ params, onSortChange }) => {
    let th = params.map(param => {
        let onClick;

        if(param === 'cpc') onClick = () => onSortChange(param);

        return <th onClick={onClick} key={param}>{capitalize(param)}</th>;
    });

    return (
        <thead>
            <tr>
                {th}
                <th>Action</th>
            </tr>
        </thead>
    )
};

export default Head;



// WEBPACK FOOTER //
// ./src/scenes/BidderSpy/components/Table/components/Head/index.js